import { createAction } from "@reduxjs/toolkit";
import {
  ADD_USER,
  ADD_USER_BLOCKED,
  ADD_USER_CONTACTS,
  ADD_USERS,
  AddUserBlockedActionType,
  AddUserContactsActionType,
  AddUsersActionType,
  DELETE_USER_CONTACT,
  DeleteUserContactActionType,
  GET_USER,
  GetUserActionType,
  GOTO_USER,
  GoToUserActionType,
  REMOVE_USER_BLOCKED,
  RemoveUserBlockedActionType,
  SET_USER_STATUS,
  SET_USER_STORAGE_SETTINGS,
  SetUserStatusActionType,
  UPDATE_USER,
  UpdateUserActionType,
} from "./types";

export const addUsers = createAction<AddUsersActionType["payload"]>(ADD_USERS);
export const addUser = createAction<AddUsersActionType["payload"][number]>(ADD_USER);
export const getUser = createAction<GetUserActionType["payload"]>(GET_USER);
export const goToUser = createAction<GoToUserActionType["payload"]>(GOTO_USER);
export const updateUser = createAction<UpdateUserActionType["payload"]>(UPDATE_USER);
export const addUserContacts = createAction<AddUserContactsActionType["payload"]>(ADD_USER_CONTACTS);
export const deleteUserContacts = createAction<DeleteUserContactActionType["payload"]>(DELETE_USER_CONTACT);
export const addUserBlocked = createAction<AddUserBlockedActionType["payload"]>(ADD_USER_BLOCKED);
export const removeUserBlocked = createAction<RemoveUserBlockedActionType["payload"]>(REMOVE_USER_BLOCKED);
export const setUserStatus = createAction<SetUserStatusActionType["payload"]>(SET_USER_STATUS);
export const setUserStorage = createAction<any>(SET_USER_STORAGE_SETTINGS);
